import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "incentivedeals",
    defaultRoutePath: "/administrations/incentivedeal",
    menuItemScope: "administration",
    menuItemName: "incentivedeals",

    routes: [
        {
            path: "/administrations/incentivedeal",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Wizards.Create,
        },
    ],

}

export default Module;
